export default function selector(storeState) {
    const { isDealAdsOpen, ...modalState } = storeState ? storeState.dealAdsModal : {};
    const { timezone } = storeState ? storeState.dealsTable : {};

    return {
        open: isDealAdsOpen,
        ...modalState,
        timezone,
    };
}
